(() => {
  const init = () => {
    document.querySelectorAll('[data-velvet-conversion]').forEach((root) => {
      if (root.dataset.velvetReady === 'true') return;
      root.dataset.velvetReady = 'true';

      // Automatically surface up to 3 real benefits from the product description.
      const source = root.querySelector('.velvet-description-source');
      const benefits = root.querySelector('[data-velvet-benefits]');
      const list = root.querySelector('[data-velvet-benefits-list]');
      if (source && benefits && list) {
        const tmp = document.createElement('div');
        tmp.innerHTML = source.innerHTML;
        const items = [...tmp.querySelectorAll('li')]
          .map((li) => li.textContent.replace(/\s+/g, ' ').trim())
          .filter((text) => text.length > 8 && text.length < 180)
          .slice(0, 3);
        if (items.length) {
          list.innerHTML = items.map((text) => `<li><span aria-hidden="true">✓</span><span>${escapeHtml(text)}</span></li>`).join('');
          benefits.hidden = false;
        }
      }

      const variantsNode = root.parentElement?.querySelector('[data-velvet-variants]') || document.querySelector('[data-velvet-variants]');
      let variants = [];
      try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}

      const stock = root.querySelector('[data-velvet-stock]');
      const stockText = root.querySelector('[data-velvet-stock-text]');
      const stockStrings = {
        soldOut: root.dataset.stockSoldOut || '',
        inStock: root.dataset.stockInStock || '',
      };

      const updateStock = (variantId) => {
        const variant = variants.find((v) => String(v.id) === String(variantId));
        if (!variant || !stockText) return;
        stock.classList.toggle('is-sold-out', !variant.available);
        if (!variant.available) {
          stockText.textContent = stockStrings.soldOut;
          return;
        }
        // Shopify's product JSON does not always expose quantity. Keep urgency factual only when initial Liquid quantity is known.
        if (String(stock.dataset.variantId) === String(variant.id)) return;
        stockText.textContent = stockStrings.inStock;
      };

      const productInfo = root.closest('product-info') || document.querySelector('product-info');
      if (productInfo) {
        productInfo.addEventListener('change', () => {
          window.setTimeout(() => {
            const variantInput = productInfo.querySelector('form[data-type="add-to-cart-form"] .product-variant-id');
            if (variantInput) updateStock(variantInput.value);
          }, 60);
        });
      }
    });

    initStickyBar();
  };

  const escapeHtml = (str) => str.replace(/[&<>'"]/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]));

  const initStickyBar = () => {
    const bar = document.querySelector('[data-velvet-sticky-atc]');
    const original = document.querySelector('[id^="ProductSubmitButton-"]');
    const productInfo = document.querySelector('product-info');
    if (!bar || !original || !productInfo || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const stickyButton = bar.querySelector('[data-velvet-sticky-button]');
    const stickyPrice = bar.querySelector('[data-velvet-sticky-price]');

    const sync = () => {
      const variantInput = productInfo.querySelector('form[data-type="add-to-cart-form"] .product-variant-id');
      const price = productInfo.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
      if (stickyPrice && price) stickyPrice.textContent = price.textContent.trim();
      if (stickyButton) {
        stickyButton.disabled = original.disabled;
        const originalText = original.querySelector('span')?.textContent?.trim();
        stickyButton.textContent = originalText || bar.dataset.addToCart || '';
      }
      bar.dataset.variantId = variantInput?.value || '';
    };
    sync();

    productInfo.addEventListener('change', () => setTimeout(sync, 70));
    new MutationObserver(sync).observe(original, { attributes: true, childList: true, subtree: true });

    stickyButton?.addEventListener('click', () => {
      if (!original.disabled) original.click();
    });

    const observer = new IntersectionObserver(([entry]) => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible', mobile && !entry.isIntersecting && window.scrollY > 350);
    }, { threshold: 0.1 });
    observer.observe(original);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
